import React from 'react';
import { Gamepad2 } from 'lucide-react';
import { createIframeGame } from './IframeGameActivity';

export default createIframeGame({
  id: 'snake-legacy',
  displayName: 'Cyber Snake (Legacy)',
  shortDescription: 'Standalone single-player Snake.',
  leaderboard: 'score',
  url: 'https://snake-chatterbawx.pages.dev/',
  icon: Gamepad2,
  attribution: {
    text: 'Snake — MIT — github.com/Chimthuwu/Snake',
    license: 'MIT',
    href: 'https://github.com/Chimthuwu/Snake',
  },
});
